import { useDispatch } from 'react-redux';
import { deleteOnsiteInterview } from '~/actions/PermanentJobs';
import { useAppSelector, useToggle } from '~/hooks';

interface IUseDeleteWorkingInterviewPayload {
  jobPostingId: string | undefined;
}

export const useDeleteOnsiteInterview = ({ jobPostingId }: IUseDeleteWorkingInterviewPayload) => {
  const dispatch = useDispatch();
  const [isWarningOpen, controls] = useToggle();

  const interviews = useAppSelector((state) => {
    if (!jobPostingId) return [];
    return state.permanentJobs.onsiteInterviews[jobPostingId] ?? [];
  });

  const onDelete = (id: string) => {
    if (!jobPostingId) return;
    if (interviews.length === 1) {
      controls.setOn();
      return;
    }

    dispatch(deleteOnsiteInterview({ id, jobPostingId }));
  };

  return {
    isWarningOpen,
    onCloseWarning: controls.setOff,
    onDelete,
  };
};
